interface NewBadgeProps {
  isNew?: boolean
}

const BADGE_CLASSES = 'absolute top-2 right-2 z-10 h-7 xl:h-8 px-2 bg-custom-red text-white text-xs xl:text-sm font-bold flex items-center justify-center font-sec-font'

export function NewBadge({ isNew }: NewBadgeProps) {
  if (!isNew) return null

  return (
    <span className={BADGE_CLASSES} aria-label="Produs nou">
      NOU
    </span>
  )
}
